import {useCallback, useState} from 'react';
import {Swiper as ISwiper} from 'swiper';

export default function useSwiperProgressState() {
  const [swiperState, setSwiperState] = useState<{
    isBeginning: boolean;
    isEnd: boolean;
  }>();
  const onProgress = useCallback(
    (swiper: ISwiper) =>
      setSwiperState({isBeginning: swiper.isBeginning, isEnd: swiper.isEnd}),
    [],
  );
  return {swiperState, onProgress};
}
